
<template>
    <select v-model="valSelected">
        <option v-if="blnHasEmptyValue === true" :value=-1>N/A</option>
        <option v-else disabled :value=-1>--{{ $t('general.pleaseSelect') }}--</option>
        <option v-if="valSelected == -2" :value=-2>--{{ $t('general.pleaseSelect') }}--</option>
        <option v-if="manufacturerId != 1" :value=7>XXS</option>
        <option :value=0>XS</option>
        <option :value=1>S</option>
        <option :value=2>M</option>
        <option :value=3>L</option>
        <option :value=4>XL</option>
        <option :value=5>XXL</option>
        <option :value=6>3XL</option>
        <option v-if="manufacturerId != 1" :value=8>4XL</option>
        <option v-if="manufacturerId != 1" :value=9>5XL</option>
    </select>

</template>

<script>
    //import * as general from '@/scripts/General.js';

    export default {
        name: 'SizeDropdown',
        props: {
            value: {type: Number},
            manufacturerId: { type: Number },
            blnHasEmptyValue: {
                type: Boolean,
                default: false,
            }
            },
        data: function () {

            return {
                valSelected: this.value,
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        },
        computed: {

        },
        watch: {
            value: function (newValue) {
                this.valSelected = newValue;
            },
            valSelected: function (newValue) {
                this.$emit('input', newValue)
            },
        },

    }
</script>
